import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useViewport } from '../hooks/useViewport';
import { useReducedMotion } from '../hooks/useReducedMotion';

/**
 * Site-wide DOM safeguards: route marker on body, viewport/reduced-motion on html.
 */
export default function AppShellEffects() {
    const { pathname } = useLocation();
    const { isMobile } = useViewport();
    const reducedMotion = useReducedMotion();

    useEffect(() => {
        document.body.dataset.route = pathname;
        const isSensorShare = /^\/s\//i.test(pathname);
        document.body.classList.toggle('app-route-sensor-share', isSensorShare);
        return () => {
            delete document.body.dataset.route;
            document.body.classList.remove('app-route-sensor-share');
        };
    }, [pathname]);

    useEffect(() => {
        const root = document.documentElement;
        root.classList.toggle('app-viewport-mobile', isMobile);
        root.classList.toggle('app-reduced-motion', reducedMotion);
        return () => {
            root.classList.remove('app-viewport-mobile', 'app-reduced-motion');
        };
    }, [isMobile, reducedMotion]);

    return null;
}
